export function getUTMFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const utm: Record<string, string> = {};
  params.forEach((value, key) => {
    if (key.startsWith('utm_')) utm[key] = value;
  });
  return utm;
}

export function saveUTM(utm: Record<string, string>) {
  Object.keys(utm).forEach(key => {
    if (key.startsWith('utm_') && utm[key]) localStorage.setItem(key, utm[key]);
  });
}

export function getSavedUTM() {
  const utm: Record<string, string> = {};
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key && key.startsWith('utm_')) {
      const value = localStorage.getItem(key);
      if (value) utm[key] = value;
    }
  }
  return utm;
}

export function updateUTMFromUrl() {
  const utm = getUTMFromUrl();
  if (Object.keys(utm).length > 0) {
    saveUTM(utm);
  }
} 